import React from 'react';

export const PeopleIcon = (): React.JSX.Element => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 34 28"
			width="100%"
			height="auto"
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M18.75 7.292a4.167 4.167 0 1 1 8.333 0 4.167 4.167 0 0 1-8.333 0M22.916 0a7.292 7.292 0 1 0 0 14.583 7.292 7.292 0 0 0 0-14.583M6.25 9.375a2.083 2.083 0 1 1 4.166 0 2.083 2.083 0 0 1-4.166 0m2.083-5.208a5.208 5.208 0 1 0 0 10.416 5.208 5.208 0 0 0 0-10.416m-2.864 12.5A5.47 5.47 0 0 0 0 22.136V25h3.125v-2.864a2.344 2.344 0 0 1 2.344-2.344h4.947v-3.125zm7.03 7.291a7.29 7.29 0 0 1 7.292-7.291h6.25a7.29 7.29 0 0 1 7.292 7.291v3.125h-3.125v-3.125a4.167 4.167 0 0 0-4.166-4.166h-6.25a4.167 4.167 0 0 0-4.167 4.166v3.125H12.5z"
				clipRule="evenodd"
			/>
		</svg>
	);
};
